import React, {Component} from "react";
import DashboardOitSelect from "./DashboardOitSelect";
import './DashboardOitReport.scss'
import classNames from 'classnames'
import DashboardFtoSelect from "./DashboardFtoSelect";

class DashboardOitReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ftoGuid: '',
      expanded: false
    }

    this.onPopState = this.onPopState.bind(this)
  }

  toggleExpanded() {
    if(this.state.expanded) {
      this.setState({expanded: false, oitGuid: ''})
      document.body.classList.remove('report-opened')
        window.removeEventListener('popstate', this.onPopState)
        setTimeout(() => {
            history.back()
        })
    } else {
      document.body.classList.add('report-opened')
        const url = new URL(location);
        url.searchParams.set("title", this.props.title);
        history.pushState({}, "", url);
        window.addEventListener('popstate', this.onPopState)
      this.setState({expanded: true})
    }
  }

    onPopState(event) {
        if(this.state.expanded) {
            this.setState({expanded: false, oitGuid: ''})
            document.body.classList.remove('report-opened')
        }
    }

  render() {
    return (
      <div className={classNames("dashboard-oit-report", {'expanded': this.state.expanded})}>
        <div className="dashboard-oit-report-title" onClick={() => this.toggleExpanded()}>
          {this.props.title}
          {!this.state.expanded && <i className="fa fa-expand"></i>}
          {this.state.expanded && <button className="primary small button"><i className="fa fa-times"></i> Close </button>}
        </div>
        <div>
          <DashboardFtoSelect multiple={true} expanded={this.state.expanded} value={this.state.ftoGuid} onInput={(ftoGuid) => this.setState({ftoGuid})} >
            {!this.state.expanded && <button className="primary small button" onClick={() => this.toggleExpanded()}>View</button>}
          </DashboardFtoSelect>
        </div>
        { this.state.expanded && this.state.ftoGuid && this.props.children && this.props.children(this.state.ftoGuid)}
        <div className="dashboard-out-report-footer">
          Data only available if recorded in your program
        </div>
      </div>
    );
  }
}

export default DashboardOitReport;
